// extracted by mini-css-extract-plugin
export var typingIndicator = "_ku-0";